module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/youtube-circle-128.12f07770790983da.png"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/youtube-circle-128.12f07770790983da.png",width: 128,height: 128}],
        src: "https://static.sniffspot.com/packs/img/youtube-circle-128.12f07770790983da.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/youtube-circle-128.12f07770790983da.png"},
        
        width: 128,
        height: 128
      }